<div class="overlay h-100 overflow-auto">
  <div class="header-with-close p-4">
    <div class="tw-min-w-0">
      <p class="header-main-title">Badge printing history</p>
    </div>

    <button type="button" class="close-header-btn" (click)="close()" aria-label="Close badge printing history">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="p-4">
    @if(!printEntries()?.length) {
    <div class="history-empty">No prints</div>
    } @for(print of printEntries(); track print.id) {
    <div class="history-item">
      <div class="history-item__meta">
        <div class="history-item__person">
          <span class="history-item__title">{{ print.person }}</span>
          @if (print.facialRecognition) {
          <mat-icon class="history-item__face-icon" aria-label="Printed via facial recognition">face</mat-icon>
          }
        </div>
        <span class="history-item__time">{{ print.printedAt ? (print.printedAt | date : 'MMM d, y, h:mm a') : '-' }}</span>
      </div>
    </div>
    }
  </div>
</div>
